import React, {PropTypes} from 'react';
// import Spinner from './utils';

export default class TextOrInput extends React.Component {
//   propTypes: {
//     className: React.PropTypes.string,
//     text: React.PropTypes.string,
//     fieldType: React.PropTypes.string,
//     submitCallback: React.PropTypes.func,
//   }

  constructor(props) {
    super(props);

    this.state = {
      editing: false,
      submitting: false,
      draftText: this.props.text,
      text: this.props.text,
      error: false,
    }

    this.handleCancel = this.handleCancel.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.toggleEditing = this.toggleEditing.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.triggerSubmit = this.triggerSubmit.bind(this);
    this.success = this.success.bind(this);
    this.failure = this.failure.bind(this);
  }

  success() {
    this.setState({submitting: false});
  }

  failure() {
    this.setState({
      submitting: false,
      error: true
    });
  }

  handleClickOutside(e) {
    if (this.wrapperRef && !this.wrapperRef.contains(e.target)) {
      this.toggleEditing();
    }
  }

  handleCancel(e) {
    this.setState({draftText: this.state.text});
    this.toggleEditing();
  }

  toggleEditing() {
    // so we can close on outside click
    if (this.state.editing) {
      document.removeEventListener('mousedown', this.handleClickOutside);
    } else {
      document.addEventListener('mousedown', this.handleClickOutside);
    }

    this.setState({editing: !this.state.editing});
  }

  handleChange(e) {
    this.setState({draftText: e.target.value});
  }

  // actually submit the request etc.
  triggerSubmit() {
    this.setState({
      text: this.state.draftText,
      submitting: true,
    });
    // submit
    this.props.submitCallback(this.state.draftText, this.success, this.failure);
  }

  // check for enter or cancel
  handleKeyDown(e) {
    const enter_key = 13;
    const escape_key = 27;

    if (e.keyCode == enter_key) {
      this.toggleEditing();
      this.triggerSubmit();
    } else if (e.keyCode == escape_key) {
      this.toggleEditing();
    }
  }

  render() {
    let controlLinks;
    let editing;
    let textOrInput;
    let spinner;
    let error;

    if (this.state.error) {
      error = <span className="error">error!</span>
    }

    if (this.state.submitting) {
      //spinner = <Spinner />
    }

    if (this.state.editing) {
      textOrInput = <input
                      autoFocus
                      type="text"
                      id={this.props.id}
                      onChange={this.handleChange}
                      onKeyDown={this.handleKeyDown}
                      value={this.state.draftText}
                    />

      controlLinks = (
        <div>
          <a className="edit-link blue-link" onClick={this.handleCancel} href="#">CANCEL</a>
        </div>
      )

      editing = 'editing';
    } else {
      textOrInput = <span className="text">{this.state.text}</span>
      controlLinks = <div><a className="edit-link blue-link" onClick={this.toggleEditing} href="#">EDIT</a></div>
      editing = '';
    }

    return (

      <div
        className={`${this.props.className} ${editing} editable-field`}
        ref={(node) => { this.wrapperRef = node; }}
      >
        {textOrInput}
        {/* {spinner} */}
        {error}
        {controlLinks}
      </div>
    );
  }
}